import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const roundCarouselBlockDefaultVariants = {}
const roundCarouselBlockCompoundVariants = []

const roundCarouselBlockSlotNames = [
  [
    "root",
    "round-carousel-block__root"
  ]
]
const roundCarouselBlockSlotFns = /* @__PURE__ */ roundCarouselBlockSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, roundCarouselBlockDefaultVariants, getSlotCompoundVariant(roundCarouselBlockCompoundVariants, slotName))])

const roundCarouselBlockFn = memo((props = {}) => {
  return Object.fromEntries(roundCarouselBlockSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const roundCarouselBlockVariantKeys = []
const getVariantProps = (variants) => ({ ...roundCarouselBlockDefaultVariants, ...compact(variants) })

export const roundCarouselBlock = /* @__PURE__ */ Object.assign(roundCarouselBlockFn, {
  __recipe__: false,
  __name__: 'roundCarouselBlock',
  raw: (props) => props,
  variantKeys: roundCarouselBlockVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, roundCarouselBlockVariantKeys)
  },
  getVariantProps
})